// extracted by mini-css-extract-plugin
module.exports = {"user-acknowledege-container":"UserAcknowledgement_user-acknowledege-container__dZ1RM","user-acknowledege-checkbox":"UserAcknowledgement_user-acknowledege-checkbox__cDXHU"};